import { Calendar } from 'lucide-react';
import { portalColors } from './portalStyles';
import { JobHeroCard } from './JobHeroCard';
import type { CrewPortalJob, CrewPortalSettings } from '../../types/crewPortal';

interface Props {
  jobs: CrewPortalJob[];
  accentColor: string;
  firstName: string;
  /** §K — the lifecycle context; the FIRST job gets the two-way controls,
   *  the rest render read-only (handoff §4.1). */
  lifecycle?: {
    slug: string;
    settings: CrewPortalSettings;
    businessName: string;
    businessLogoUrl: string | null;
    onCompleted: () => void;
  };
}

export function TodayView({ jobs, accentColor, firstName, lifecycle }: Props) {
  if (jobs.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '48px 0' }}>
        <Calendar size={32} color={portalColors.muted} />
        <div style={{ fontSize: 15, color: portalColors.secondary, marginTop: 12 }}>
          Nothing on today — check back tomorrow or switch to This Week.
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {jobs.map((job, i) => (
        <JobHeroCard
          key={job.id}
          job={job}
          accentColor={accentColor}
          label="Today"
          firstName={firstName}
          lifecycle={i === 0 ? lifecycle : undefined}
        />
      ))}
    </div>
  );
}
